import studentApi from "./studentApi";
import { STUDENT_ENDPOINTS } from "./studentEndpoints";

// Confirmed against the shipping mobile app's API client (2026-10-22): wrap
// filters as params: { data: {...} } — a flat body is rejected server-side.
export const getSyllabus = async (params) => {
  const response = await studentApi.get(STUDENT_ENDPOINTS.SYLLABUS.GET, { params: { data: params } });
  return response;
};
